import { create } from 'zustand'

export interface TagsSlice {
  selectedTagId: string | null
  setSelectedTagId: (tagId: string | null) => void
}

export const useTags = create<TagsSlice>((set) => ({
  selectedTagId: '',
  setSelectedTagId: (tagId) => set(() => ({ selectedTagId: tagId })),
}))